'use client'
// import TabbedNewsSection from "@/app/components/TabbedNewsSection";
// import AdvertisementImage from "@/app/modules/Advertisement";
import { useCallback, useEffect, useState } from "react";
import Image from "next/image";
import { formatDateString } from "../utils/interfaces";
import Link from "next/link";


const VideosPage = () => {
	const [page, setPage] = useState<number>(1);
	const [totalPages, setTotalPages] = useState<number>(1);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
	const [articles, setArticles] = useState<any[]>([]);

	const fetchArticles = useCallback(
		async (page: number = 1, append: boolean = false) => {
			setLoading(true);
			setError(null);
			try {

				const params = new URLSearchParams();
				if (page) params.append("page", page.toString());

				const response = await fetch(
					`${API_BASE_URL}videos/?${params.toString()}`
				);
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const data = await response.json();
				const { results, total_pages } = data;

				setArticles((prev) => {
					return append ? [...prev, ...results] : results;
				});
				setTotalPages(total_pages);
			} catch (err) {
				console.error("Failed to fetch articles:", err);
				setError("Мэдээ олдсонгүй эсвэл алдаа гарлаа.");
			} finally {
				setLoading(false);
			}
		},
		[]
	);


	useEffect(() => {
		fetchArticles();
	}, [fetchArticles]);

	const handleLoadMore = () => {
		if (page < totalPages) {
			fetchArticles(page + 1, true);
			setPage((prev) => prev + 1);
		}
	};


	return (
		<div className="mx-3 md:mx-0">
			<div className="text-2xl font-semibold mb-3 bg-white mt-5 container mx-auto py-5 flex md:flex-row flex-col md:justify-between text-center shadow-sm  px-5">
				<div>Видео мэдээ</div>
				<Link className="flex flex-row items-center gap-x-2 justify-center" href="https://www.youtube.com/@Ivoice_news"
					target="_blank"
					rel="noopener noreferrer">
					<div
						className="text-gray-700 w-[40px] h-[40px] inline-block"
					>
						<svg fill="red" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>YouTube</title><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
					</div>
					@Ivoice_news
				</Link>
			</div>

			<div className="mt-5 rounded container mx-auto">
				<div className="flex flex-col col-span-10 md:col-span-7">
					{!loading && error && (
						<div className="text-center text-gray-600 mt-4">
							<p>{error}</p>
						</div>
					)}
					{!loading && !error && articles.length === 0 && (
						<div className="text-center text-gray-600 mt-4">
							<p>Мэдээ олдсонгүй.</p>
						</div>
					)}
					{
						!error &&
						articles.length > 0 && (
							<div className="grid md:grid-cols-4 grid-cols-2 gap-5">
								{articles.map((article, index) => (
									<div
										key={index}
										className="flex items-center justify-center rounded overflow-hidden bg-white"
									>
										<a href={`/video/${article.pk}`}>
											<div className="">
												<div className="w-full h-full relative">
													<Image
														src={article.thumbnail_image}
														alt={article.title}
														className="object-cover aspect-[16/9]"
														width={960}
														height={540}
													/>
													{article.is_live && <div className="absolute top-0 right-0 text-[0.7rem] bg-red-500 text-white p-2 rounded-bl uppercase font-semibold">Шууд</div>}
												</div>
												<div className="p-3">
													<div className="text-sm h-10 line-clamp-2 font-semibold">{article.title}</div>
													<div className="text-xs text-gray-500 mt-2">{formatDateString(article.published_date)}</div>
												</div>
											</div>
										</a>
									</div>
								))}
							</div>
						)}

					{loading && (
						<div className="flex justify-center items-center">
							<div className="spinner-border animate-spin inline-block w-6 h-6 border-4 border-gray-500 border-t-transparent rounded-full"></div>
						</div>
					)}
					{!loading && page < totalPages && (
						<div className="flex justify-center mt-4">
							<button
								onClick={handleLoadMore}
								className="px-4 py-4 bg-gray-400 font-semibold text-white text-sm rounded transition w-full"
							>
								Цааш үзэх
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default VideosPage;